import 'src/home'
import "controllers"
import Rails from 'rails-ujs'
Rails.start()